// 组织人员
// import {touristApi}from '../../api/system/tourist/tourist'
const organizationPersonnel = {
  state: {
    departmentList: [] // 部门列表
  },

  mutations: {},

  actions: {}
}
export default organizationPersonnel
